var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6636 7.63672C13.8581 8.2948 14.2174 8.8822 14.6935 9.35116L11.3366 11.3653C11.1421 10.7073 10.7828 10.1199 10.3066 9.65091L13.6636 7.63672Z",
    fill: "#FF1C26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3066 15.3511L13.6636 17.3653C13.8581 16.7072 14.2173 16.1198 14.6935 15.6509L11.3366 13.6367C11.1421 14.2948 10.7828 14.8822 10.3066 15.3511Z",
    fill: "#FF1C26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 8.5C18.6046 8.5 19.5 7.60457 19.5 6.5C19.5 5.39543 18.6046 4.5 17.5 4.5C16.3954 4.5 15.5 5.39543 15.5 6.5C15.5 7.60457 16.3954 8.5 17.5 8.5ZM21.5 6.5C21.5 8.70914 19.7091 10.5 17.5 10.5C15.2909 10.5 13.5 8.70914 13.5 6.5C13.5 4.29086 15.2909 2.5 17.5 2.5C19.7091 2.5 21.5 4.29086 21.5 6.5Z",
    fill: "#FF1C26"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 20.5C18.6046 20.5 19.5 19.6046 19.5 18.5C19.5 17.3954 18.6046 16.5 17.5 16.5C16.3954 16.5 15.5 17.3954 15.5 18.5C15.5 19.6046 16.3954 20.5 17.5 20.5ZM21.5 18.5C21.5 20.7091 19.7091 22.5 17.5 22.5C15.2909 22.5 13.5 20.7091 13.5 18.5C13.5 16.2909 15.2909 14.5 17.5 14.5C19.7091 14.5 21.5 16.2909 21.5 18.5Z",
    fill: "#FF1C26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 14.5C8.60457 14.5 9.5 13.6046 9.5 12.5C9.5 11.3954 8.60457 10.5 7.5 10.5C6.39543 10.5 5.5 11.3954 5.5 12.5C5.5 13.6046 6.39543 14.5 7.5 14.5ZM11.5 12.5C11.5 14.7091 9.70914 16.5 7.5 16.5C5.29086 16.5 3.5 14.7091 3.5 12.5C3.5 10.2909 5.29086 8.5 7.5 8.5C9.70914 8.5 11.5 10.2909 11.5 12.5Z",
    fill: "#FF1C26"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareRed);
export default __webpack_public_path__ + "static/media/share-red.d2bc775c6ee6e6b791150e23f1bb4c62.svg";
export { ForwardRef as ReactComponent };